<template>
    <nav
        class="navbar sticky-top bg-orange navbar-dark navbar-expand-md"
        :class="[ isProd ? 'bg-orange' : 'bg-secondary']"
    >
        <div class="container-fluid">
            <a class="navbar-brand" href="/merchant/home">
                <logo />
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto">
                    <li
                        v-for="(item, index) in getUserRoutes"
                        :key="index"
                        class="nav-item"
                    >
                        <a class="nav-link active" :href="item.path">
                            {{ item.name }}
                        </a>
                    </li>
                </ul>
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link active" href="#" @click.prevent="Logout">
                            {{ $t('navbar.logout') }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
import { router } from "@inertiajs/vue3";
import Logo from "../Logo.vue";

const Routes = [
    {
        path: "/merchant/transport/scan",
        name: "navbar.scan",
        permission: ["Super", "Moderator"]
    },
    {
        path: "/merchant/transport/normal",
        name: "navbar.transport.normal",
        permission: ["Super", "Moderator", "Reader"]
    },
    {
        path: "/merchant/transport/vip",
        name: "navbar.transport.vip",
        permission: ["Super", "Moderator", "Reader"]
    },
    {
        path: "/merchant/transportlog",
        name: "navbar.transport_log",
        permission: ["Super", "Moderator"]
    },
    {
        path: "/merchant/queue",
        name: "navbar.queue",
        permission: ["Super", "Moderator", "Monitor"]
    }
]

export default {
    name: "TopNavbar",
    props: {
        appName: String,
        isProd: Boolean,
        role: {
            type: String,
            default: ""
        }
    },
    computed: {
        getUserRoutes() {
            const allRoutes = [];
            for (const routesKey in Routes) {
                const route = Routes[routesKey];
                if (route.permission.includes(this.role)) {
                    allRoutes.push({
                        path: route.path,
                        name: this.$t(route.name),
                    });
                }
            }
            return allRoutes;
        }
    },
    methods: {
        Logout() {
            router.post("/merchant/logout")
        }
    },
    components: {
        Logo,
    }
}
</script>

<style scoped>

</style>
